import { Link, Navigate, useLocation } from 'react-router-dom'
import { CheckCircle2 } from 'lucide-react'
import { formatCurrency, formatDateLong } from '@hotel/shared/utils'
import type { ReservationSummary } from '../api/types'
import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'

export function ConfirmationPage() {
  const location = useLocation() as { state?: { reservation?: ReservationSummary } }
  const reservation = location.state?.reservation
  if (!reservation) return <Navigate to="/" replace />

  const rows: { label: string; value: string }[] = [
    { label: 'Huésped', value: reservation.guest_name },
    { label: 'Tipo', value: reservation.room_type_name },
    { label: 'Llegada', value: formatDateLong(reservation.check_in_date) },
    { label: 'Salida', value: formatDateLong(reservation.check_out_date) },
    { label: 'Total estimado', value: formatCurrency(reservation.grand_total_with_tax ?? reservation.total_amount) },
    { label: 'Estado', value: reservation.status },
  ]

  return (
    <section className="bg-cream-light pt-24 pb-12 md:pt-32 md:pb-20">
      <div className="mx-auto max-w-3xl px-4">
        <Card>
          <CardContent className="flex flex-col items-center p-6 text-center sm:p-8 md:p-10">
            <CheckCircle2 className="mb-4 h-12 w-12 text-terracotta sm:h-14 sm:w-14" />
            <p className="mb-2 text-xs font-semibold uppercase tracking-widest text-terracotta sm:text-sm">
              Reservación pendiente creada
            </p>
            <h1 className="mb-3 break-all font-heading text-2xl font-bold text-wood-dark sm:text-3xl md:text-4xl">
              {reservation.confirmation_code}
            </h1>
            <p className="mb-6 max-w-xl text-sm text-stone sm:mb-8 sm:text-base">
              Tu solicitud ya está registrada en el sistema del hotel. El equipo puede
              validarla y continuar el seguimiento desde operación interna.
            </p>
            <div className="mb-6 grid w-full gap-3 text-left sm:mb-8 sm:grid-cols-2 sm:gap-4">
              {rows.map((r) => (
                <div
                  key={r.label}
                  className="rounded-md border border-cream-dark bg-cream-light p-3 sm:p-4"
                >
                  <p className="text-xs font-semibold uppercase tracking-wider text-stone">
                    {r.label}
                  </p>
                  <p className="mt-1 break-words font-medium text-wood-dark">{r.value}</p>
                </div>
              ))}
            </div>
            <Link to="/account" className="w-full sm:w-auto">
              <Button size="lg" className="w-full sm:w-auto">Ver mis reservas</Button>
            </Link>
          </CardContent>
        </Card>
      </div>
    </section>
  )
}
